<template>
  <div style="width: 100%; min-height: 100vh; background: rgb(237, 241, 255)">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7"
      :title="pageTitle" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>
    <div class="usrse">
      <div class="hgs" v-if="type === 1 || type === 3">
        <div class="nams">原密码</div>
        <div style="border-bottom: 1px solid #f2f2f2">
          <van-cell-group>
            <van-field v-model="passwordInfo.password" type="password" placeholder="请输入当前密码" />
          </van-cell-group>
        </div>
      </div>
      <div class="hgs">
        <div class="nams">{{ type === 1 ? '新登录密码' : '新提现密码' }}</div>
        <div style="border-bottom: 1px solid #f2f2f2">
          <van-cell-group>
            <van-field v-model="passwordInfo.paypassword" type="password" placeholder="请输入新密码" />
          </van-cell-group>
        </div>
      </div>
      <div class="hgs">
        <div class="nams">确认新密码</div>
        <div style="border-bottom: 1px solid #f2f2f2">
          <van-cell-group>
            <van-field v-model="passwordInfo.newpassword" type="password" placeholder="请再次输入密码" />
          </van-cell-group>
        </div>
      </div>
      <van-button type="info" style="margin-top: 20px; width: 100%" @click="editPassword(type)">确认提交</van-button>
      <div style="height: 60px"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'password',
  data() {
    return {
      passwordInfo: {
        password: '',
        paypassword: '',
        newpassword: ''
      },
      type: 1,
    };
  },
  computed: {
    pageTitle() {
      if (this.type === 1) return '修改登录密码';
      if (this.type === 2) return '设置提现密码';
      if (this.type === 3) return '修改提现密码';
      return '设置提现密码';
    }
  },
  created() {
    this.getTypeFromRoute();
  },
  watch:{
    '$route.query.type'(){
      this.getTypeFromRoute();
    }
  },
  methods: {
    getTypeFromRoute(){
      const query = this.$route.query;
      if (query.type) {
        this.type = parseInt(query.type);
      }
      console.log('当前页面type值：',this.type)
    },
    editPassword(pasType) {
      if (pasType === 1 || pasType === 3) {
        if (!this.passwordInfo.password) {
          this.$parent.showTost(0, '请输入原密码');
          return;
        }
        if (this.passwordInfo.password.length < 6) {
          this.$parent.showTost(0, '请输入正确的原密码长度');
          return;
        }
      }
      if (!this.passwordInfo.paypassword) {
        this.$parent.showTost(0, '请输入新密码');
        return;
      }
      if (this.passwordInfo.paypassword.length < 6) {
        this.$parent.showTost(0, '新密码最少6位');
        return;
      }
      if (!this.passwordInfo.newpassword) {
        this.$parent.showTost(0, '请输入确认密码');
        return;
      }
      if (this.passwordInfo.newpassword !== this.passwordInfo.paypassword) {
        this.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (pasType === 1 || pasType === 3) {
        if (this.passwordInfo.password === this.passwordInfo.paypassword) {
          this.$parent.showTost(0, '新旧密码不能一致！');
          this.passwordInfo = {};
          return;
        }
      }
      let url = '';
      if (pasType === 1) {
        url = '/api/editPassword';
      } else if (pasType === 2) {
        url = '/api/setPayPassword';
      } else {
        url = '/api/editPayPassword';
      }
      let postData = {
        paypassword: this.passwordInfo.paypassword,
      };
      if (pasType === 1 || pasType === 3) {
        postData.password = this.passwordInfo.password;
      }
      this.$parent.showLoading();
      this.$apiFun.post(url, postData).then(res => {
        this.$parent.hideLoading();
        if (res.code !== 200) {
          this.$parent.showTost(0, res.message);
          return;
        }
        let successMsg = '';
        if(pasType === 1){
          successMsg = '登录密码修改成功！'
        }else if(pasType === 2){
          successMsg = '提现密码设置成功！'
        }else if(pasType === 3){
          successMsg = '提现密码修改成功！'
        }
        this.$parent.showTost(1, successMsg);
        this.passwordInfo = {};
        if (pasType == 1) {
          this.$parent.closeDaoTime();
          localStorage.clear();
          sessionStorage.clear();
          this.$store.commit('changUserInfo');
          this.$store.commit('changToken');
          this.$router.push({ path: '/login' });
        } else {
          setTimeout(() => {
            this.$router.back();
          }, 800);
        }
      }).catch(()=>{
        this.$parent.hideLoading();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.usrse {
  background: #fff;
  box-sizing: border-box;
  padding: 6px 20px 0;
  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
    margin-top: 10px;
    font-weight: 700;
  }
}
[class*='van-hairline']:after {
  border: none;
}
</style>
